import React from 'react';
import { useContentLoading } from '../../contexts/ContentLoadingContext';
import ContentLoader from '../Loader/ContentLoader';

interface ContentWrapperProps {
  children: React.ReactNode;
  className?: string;
  loaderVariant?: 'default' | 'minimal' | 'card';
  loaderSize?: 'small' | 'medium' | 'large';
}

const ContentWrapper: React.FC<ContentWrapperProps> = ({ 
  children, 
  className = '', 
  loaderVariant = 'default',
  loaderSize = 'medium'
}) => {
  const { isContentLoading, contentLoadingText } = useContentLoading();

  return (
    <div className={`content-wrapper ${className}`} style={{ position: 'relative', minHeight: '300px' }}>
      {isContentLoading && (
        <ContentLoader 
          text={contentLoadingText} 
          variant={loaderVariant}
          size={loaderSize}
        />
      )}
      {children}
    </div>
  );
};

export default ContentWrapper;